<!-- container-xxl -->
<div class="content-wrapper key-initiatives-content-wrapper p-0 filter-outer-container">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body content-body-outer-img-container">
		<img src="assets\images\our-projects-img\Group 159.png" alt="our-project">
	</div>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
			<!-- Related Products starts -->
			<!-- <div class="card-body"> -->
			<h3 class="text-center mb-1">Key Projects (Ongoing Projects)</h3>
			<h4>Solar PV</h4>
			<div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th>Sr. No.</th>
							<th>Title of the Project</th>
							<th>Name of the PI and Institution</th>
							<th>Project Cost, MNRE Share (Rs. in Lakh) and Duration</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">National Centre for Photovoltaic Research and Education (NCPRE) Phase-II</td>
							<td scope="col" class="text-wrap">Prof. B G Fernandes, Indian Institute of Technology (IIT) Mumbai</td>
							<td scope="col" class="text-wrap">
								<p>Project cost = Rs. 6235 Lakhs<br>
								 MNRE share = 100%<br>
									Duration = 5 years<br>
									(Project completed)
								</p>
								
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">2</td>
							<td scope="col" class="text-wrap">National Centre for Photovoltaic Research and Education (NCPRE) Phase-III
							</td>
							<td scope="col" class="text-wrap">Prof. B G Fernandes, Indian Institute of Technology (IIT) Mumbai</td>
							<td scope="col" class="text-wrap">
								<p>Project cost = Rs. 4092 Lakhs<br>
									MNRE share = 100% <br>
									Duration = 4 years
								</p>
							</td>
						</tr>
						<tr>
							<td style="text-align: center;">3</td>
							<td scope="col" class="text-wrap">National Primary Standard facility for cell calibration</td>
							<td scope="col" class="text-wrap">Dr. Prathap Pathi National Physical Laboratory (NPL), Delhi <br>
								
							</td>
							<td scope="col" class="text-wrap">
								<p>
									Project cost = Rs. 2166.76 Lakhs<br>
									MNRE share = 100% <br>
									Duration = 3 years <br>
								</p>
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">4</td>
							<td scope="col" class="text-wrap">Development of high efficiency (21%/ 19%) PERC type of c-Si/mc-Si solar cell
							</td>
							<td scope="col" class="text-wrap">Dr. B. K. Pant, Head, BHEL-ASSCP, Gurugram</td>
							<td scope="col" class="text-wrap">
								<p>
								 Project cost = Rs. 5433 lakhs <br>
                                 MNRE share = Rs.2628 Lakhs <br>
                                 Duration = 3 years <br>
								 (Project completed) <br>
								</p>
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">5</td>
							<td scope="col" class="text-wrap">Flexible Perovskite Solar Cells and Intermediate Module</td>
							<td scope="col" class="text-wrap">Prof. Shaibal K. Sarkar, Indian Institute of Technology Bombay, Powai, Mumbai</td>
							<td scope="col" class="text-wrap">
								<p>
									Project cost = Rs 830 lakh<br>
									MNRE share = 100% <br>
									Duration = 3 years <br>
								</p>
							</td>
						</tr>
						
					</tbody>
				</table>
			</div><br />
			<h4>Wind Energy</h4>
			<div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th>Sr. No.</th>
							<th>Title of the Project</th>
							<th>Name of the PI and Institution</th>
							<th>Project Cost, MNRE Share (Rs. in Lakh) and Duration</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">Integrated Wind and Solar resource Assessment</td>
							<td scope="col" class="text-wrap">Director General, National Institute of Wind Energy (NIWE), Chennai</td>
							<td scope="col" class="text-wrap">Project cost = Rs. 1799 lakhs<br>
								MNRE share = 100%<br>
								Duration = 5 years<br>
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">2</td>
							<td scope="col" class="text-wrap">Met-Ocean Measurements (Wind, Wave, Tide, Current, Water Level, etc.,) at Gulf of Khambhat and Gulf of Mannar</td>
							<td scope="col" class="text-wrap">Director General, National Institute of Wind Energy (NIWE), Chennai</td>
							<td scope="col" class="text-wrap">
								Project cost = Rs. 4464 lakhs<br>
								MNRE share = 100% <br>
								Duration = 5 years 
							</td>
						</tr>
					</tbody>
				</table>
			</div><br />
			<h4>Small Hydro Power</h4>
			<div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th>Sr. No.</th>
							<th>Title of the Project</th>
							<th>Name of the PI and Institution</th>
							<th>Project Cost, MNRE Share (Rs. in Lakh) and Duration</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">Centre of Excellence titled “Research and development of Ultra Low head and Hydrokinetic Turbines and performance
								prediction of small hydro turbine models.</td>
							<td scope="col" class="text-wrap">Prof. Arun Kumar, Indian Institute of Technology (IIT), Roorkee</td>
							<td scope="col" class="text-wrap">Project cost = Rs. 1908 lakhs<br>
								MNRE share = 100%<br>
								Duration = 4 years
							</td>
							
						</tr>
						
					</tbody>
				</table>
			</div><br />
			<h4>Waste to Energy</h4>
			<div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th>Sr. No.</th>
							<th>Title of the Project</th>
							<th>Name of the PI and Institution</th>
							<th>Project Cost, MNRE Share (Rs. in Lakh) and Duration</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">Biomass Gasification through Plasma Pyrolysis Technology for Chemicals Production</td>
							<td scope="col" class="text-wrap">Prof. Vimal Kumar, Associate Professor,
								Indian Institute of Technology (IIT), Roorkee</td>
							<td scope="col" class="text-wrap">
								Project cost = Rs. 44.71 lakhs<br>
								MNRE share = 100%<br>
								Duration = 3 years
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">2</td>
							<td scope="col" class="text-wrap">Densification and co-firing of agro-waste for power generation through gasification</td>
							<td scope="col" class="text-wrap">Dr. Tapas Patra,
								Sardar Swaran Singh National Institute of Bio-Energy (SSS-NIBE), Kapurthala, Punjab</td>
							<td scope="col" class="text-wrap">
								Project cost = Rs. 40.45 lakhs<br>
								MNRE share = 100%<br>
								Duration = 2.5 years<br>

							</td>
							
						</tr>
					</tbody>
				</table>
			</div><br />
			<h4>Hydrogen Energy</h4>
			<div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th style="width:10%">Sr. No.</th>
							<th style="width:15%">Title of the Project</th>
							<th style="width:15%">Name of the PI and Institution</th>
							<th style="width:30%">Project Cost, MNRE Share (Rs. in Lakh) and Duration</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">Green Hydrogen Mobility Projects at Leh</td>
							<td scope="col" class="text-wrap">Sh. DMR Panda,
								General Manager
								NTPC Ltd., Noida, U.P.</td>
							<td scope="col" class="text-wrap">
								Project Cost = Rs. 7227 lakh <br>
								MNRE Share = Rs. 2598.5 lakhs <br>
								Duration = 3 years 

							</td>
						</tr>
						
						<tr>
							<td style="text-align: center;">2</td>
							<td scope="col" class="text-wrap">Design & development of 20kW Low Temperature Polymer Electrolyte Membrane Fuel Cell (LTPEMFC) with high indigenous
								content</td>
							<td scope="col" class="text-wrap">Dr. R. Balaji
								ARCI-Centre for Fuel Cell Technology, Chennai</td>
							<td scope="col" class="text-wrap">
							   Total Project Cost= Rs 2138.74 lakhs<br>
                               MNRE Share= Rs 1773.74 lakhs<br>
                               Duration= 3 years
							</td>
							
						</tr>
						<tr>
							<td style="text-align: center;">3</td>
							<td scope="col" class="text-wrap">Setting Up of a Centre of Excellence on Hydrogen Energy at National Institute of Solar Energy (NISE), Gwal Pahari,
								Haryana</td>
							<td scope="col" class="text-wrap">Director General, National Institute of Solar Energy (NISE), Gurugram, Haryana</td>
							<td scope="col" class="text-wrap">
								Total Project Cost= Rs.1030.47 lakhs<br>
								Duration= 3 years
								
							</td>
						</tr>
						
					</tbody>
				</table>
			</div><br />
			<!-- <h4>Bio Energy</h4>
          <div class="table-responsive table-bordered">
            <table class="table mb-0 table-striped table-bordered">
              <thead>
              <tr>
                <th>S. No.</th>
                <th>Name of the Project</th>
                <th>Implementing Agency</th>
                <th>Total cost  </th>
              </tr>                  
            </thead>
            <tbody>
              <tr>
                <td style="text-align: center;">17</td>
                <td scope="col" class="text-wrap">Bio gas from Paddy straw</td>
                <td scope="col" class="text-wrap">IIT Delhi</td>
                <td scope="col" class="text-wrap">Total cost: 49 Lakh </td>
              </tr>
            </tbody>
            </table>
          </div> -->
			<!-- </div> -->
			<!-- </div> -->
		</section>
	</div>
</div>